import { render } from "./InformationFrom.vue?vue&type=template&id=304ac30f&scoped=true&ts=true"
import script from "./InformationFrom.vue?vue&type=script&lang=ts"
export * from "./InformationFrom.vue?vue&type=script&lang=ts"

import "./InformationFrom.vue?vue&type=style&index=0&id=304ac30f&scoped=true&lang=scss"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304ac30f"]])

export default __exports__